
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/game/guide/[id]/weapon/[weaponId]",
      function () {
        return require("private-next-pages/game/guide/[id]/weapon/[weaponId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/game/guide/[id]/weapon/[weaponId]"])
      });
    }
  